@if (overlay.state(); as modal) {
  <div class="overlay-backdrop" (click)="overlay.cancel()">
    <section
      class="overlay-dialog"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="modal.type + '-title'"
      (click)="$event.stopPropagation()"
    >
      @if (modal.type === 'loading') {
        <div class="overlay-spinner" role="status" aria-label="กำลังโหลด"></div>
      } @else if (modal.type === 'success') {
        <div class="overlay-icon success-icon">
          <lucide-icon name="CircleCheck" [size]="44" aria-hidden="true" />
        </div>
      } @else if (modal.type === 'error') {
        <div class="overlay-icon error-icon">
          <lucide-icon name="CircleX" [size]="44" aria-hidden="true" />
        </div>
      } @else {
        <div class="overlay-icon confirm-icon">
          <lucide-icon name="CircleHelp" [size]="44" aria-hidden="true" />
        </div>
      }

      <h2 [id]="modal.type + '-title'">{{ modal.title }}</h2>
      @if (modal.message) {
        <p>{{ modal.message }}</p>
      }

      @if (modal.type !== 'loading') {
        <div class="overlay-actions">
          @if (modal.type === 'confirm') {
            <button class="overlay-button cancel-button" type="button" (click)="overlay.cancel()">
              {{ modal.cancelText }}
            </button>
          }
          <button class="overlay-button confirm-button" type="button" (click)="overlay.accept()">
            {{ modal.confirmText }}
          </button>
        </div>
      }
    </section>
  </div>
}
